import { BaseModal, Button, Container, Illustration, Text, useBreakpoint } from '@melio/penny';
import { FeatureFlags, useFeature } from '@melio/platform-feature-flags';
import { useMelioIntl } from '@melio/platform-i18n';
import { useSubscription } from '@melio/subscriptions-sdk';

type SubscriptionCancelSuccessModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const SubscriptionCancelSuccessModalActivity = ({ isOpen, onClose }: SubscriptionCancelSuccessModalProps) => {
  const [isPlatformSubscriptionsEnabled] = useFeature(FeatureFlags.PlatformSubscriptions, false);
  const { subscription } = useSubscription();
  const { formatMessage, formatDate } = useMelioIntl();
  const { isExtraSmallScreen } = useBreakpoint();
  const isModalOpen = isOpen && isPlatformSubscriptionsEnabled;

  const formattedNextBillingDate = formatDate(subscription?.nextBillingDate, {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

  const modalPadding = isExtraSmallScreen ? 'm' : 'xxl';

  return (
    <BaseModal isOpen={isModalOpen} onClose={onClose} data-testid="subscription-cancel-success-modal-activity">
      <Container paddingX={modalPadding} paddingY={modalPadding} overflow="auto">
        <Container paddingBottom="s">
          <Illustration type="page-not-found" />
        </Container>

        <Text as="h1" textStyle="heading2Semi">
          {formatMessage('activities.subscription.cancelSuccessModal.title')}
        </Text>

        <Container paddingTop="s" paddingBottom="xl">
          <Text textStyle="body2">
            {formatMessage('activities.subscription.cancelSuccessModal.description', {
              date: formattedNextBillingDate,
            })}
          </Text>
        </Container>

        <Button
          label={formatMessage('activities.subscription.cancelSuccessModal.primaryButton')}
          isFullWidth
          onClick={onClose}
        />
      </Container>
    </BaseModal>
  );
};
